module.exports = __webpack_public_path__ + "img/second-2.c68b8ab6.webp";